export class PaymentInvoice {

    id: number = 0;
    invoice_id: number;
    payment_id: number;
    type: string;
    amount: number;
    effective_date: string;
    created_by: number = 0;
    created_on: string = '';
    created_by_user_name: string = '';
    created_by_first_name: string = '';
    created_by_last_name: string = '';
    last_updated_by: number = 0;
    last_updated: string = '';
    last_updated_user_name: string = '';
    last_updated_first_name: string = '';
    last_updated_last_name: string = '';

    constructor(init?:Partial<PaymentInvoice>) {
        Object.assign(this, init);
    }
    
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/payment-invoice.ts